import CardPillLabel from "../../components/ui/CardPillLabel";
import { contactData } from "../../features/contact/data/contactData";
import { IconMail, IconPhone } from "../../components/ui/Icons";

const privacySections = [
  {
    title: "Podstawowe informacje",
    items: [
      "Brak rejestracji użytkowników i systemu logowania.",
      "Strona nie zbiera aktywnie danych osobowych użytkowników.",
    ],
  },
  {
    title: "Dane techniczne (infrastruktura)",
    items: [
      "Adres IP",
      "Informacje o przeglądarce i urządzeniu",
      "Dane związane z połączeniem i bezpieczeństwem",
    ],
  },
  {
    title: "Cel przetwarzania",
    items: [
      "Zapewnienie poprawnego działania strony",
      "Zwiększenie wydajności serwisu",
      "Ochrona przed nadużyciami",
    ],
  },
  {
    title: "Podsumowanie",
    summary:
      "Strona nie wykorzystuje tych danych do identyfikacji użytkownika ani profilowania. Żadne dane nie są przekazywane podmiotom trzecim w celach marketingowych.",
  },
];

export default function KontaktPage() {
  return (
    <section className="pageSection pageWithHeaderOffset">
      <div className="container">

        <div className="card cardLabeled">
          <CardPillLabel text="Kontakt" variant="kontakt" />
          <h1 className="h1">Jak możemy pomóc?</h1>
          <p className="pageLead" style={{ marginTop: 4 }}>
            {contactData.lead}
          </p>

          <div className="contactPageGrid" style={{ marginTop: 16 }}>
            {contactData.cards.map((card) => (
              <div key={card.title} className="contactCard">
                <div className="contactCardHeader">
                  <span className="contactCardRole">{card.title}</span>
                  <strong className="contactCardName">{card.name}</strong>
                </div>

                <div className="contactCardLinks">
                  {card.phone !== "-" && (
                    <a
                      className="contactLink"
                      href={`tel:${card.phone.replace(/\s+/g, "")}`}
                      aria-label={`Zadzwoń do ${card.name}: ${card.phone}`}
                    >
                      <span className="contactLinkIcon">
                        <IconPhone />
                      </span>
                      <span className="contactLinkText">
                        <span className="contactLinkLabel">Telefon</span>
                        <span className="contactLinkValue">{card.phone}</span>
                      </span>
                    </a>
                  )}

                  <a
                    className="contactLink"
                    href={`mailto:${card.email}`}
                    aria-label={`Napisz do ${card.name}: ${card.email}`}
                  >
                    <span className="contactLinkIcon">
                      <IconMail />
                    </span>
                    <span className="contactLinkText">
                      <span className="contactLinkLabel">Email</span>
                      <span className="contactLinkValue">{card.email}</span>
                    </span>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="card cardLabeled" style={{ marginTop: 14 }}>
          <CardPillLabel text="Dane i prywatność" variant="mapa" />
          <h2 className="h2">Informacja o stronie i danych</h2>
          <p className="pageLead" style={{ marginTop: 4 }}>
            Strona nie wykorzystuje plików cookie ani innych technologii
            śledzących. Nie zbiera, nie przetwarza ani nie udostępnia danych
            osobowych użytkowników. Serwis ma charakter wyłącznie informacyjny.
          </p>

          <div className="privacyGrid">
            {privacySections.map((section) => (
              <div key={section.title} className="privacyBlock">
                <h3 className="privacyBlockTitle">{section.title}</h3>
                {section.items ? (
                  <ul className="privacyList">
                    {section.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                ) : (
                  <p className="privacyBlockText">{section.summary}</p>
                )}
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
